import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllComplaintsResponseModel, ComplaiintsResponseModel } from '@gtpl/shared-models/hrms';
import { InjectRepository } from '@nestjs/typeorm';
import { Entity, Repository } from 'typeorm';
import { ComplaintsRequest } from './dto/complaints.request';
import { ComplaintsDTO } from './dto/complaints.dto';
import { ComplaintsAdapter } from './dto/complaints.adapter';
import { ComplaintsEntity } from './complaints.entity';
import { Departments } from 'apps/services/masters/src/app/departments/departments.entity';
import { DepartmentDto } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
@Injectable()
export class ComplaintsService {

    constructor(
      private logService:LogsService,

        @InjectRepository(ComplaintsEntity)
        private complaintsRepo: Repository<ComplaintsEntity>,
        private complaintsAdapter: ComplaintsAdapter,
    ){}

    async getComplaint(complaint: string,departmentId:number): Promise<ComplaintsEntity>{
        const response = await this.complaintsRepo.findOne({
            where: {complaint: complaint ,departmentId:departmentId },
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async createComplaint(data: ComplaintsDTO, isUpdate: boolean): Promise<ComplaiintsResponseModel>{
        try{
            if(!isUpdate){
                const complaintsEntity = await this.getComplaint(data.complaint,data.departmentId);
                if(complaintsEntity){
                    throw new ErrorResponse(11104, 'Complaint already exists with same Department');
                }
            }else{
                const complaintsEntity = await this.getComplaint(data.complaint,data.departmentId);
                if(complaintsEntity){
                    if(complaintsEntity.complaintId != data.complaintId){
                        throw new ErrorResponse(11104, 'Complaint already exists');
                    }
                }
            }
            const convertedComplaintsEntity: ComplaintsEntity = this.complaintsAdapter.convertDtoToEntity(data);
            const savedComplaint: ComplaintsEntity = await this.complaintsRepo.save(convertedComplaintsEntity);
            const convertedComplaint: ComplaintsDTO = await this.complaintsAdapter.convertEntityToDto(savedComplaint);

            if(convertedComplaint){
                const response = new ComplaiintsResponseModel(true, isUpdate? 11100: 11101, isUpdate? 'Complaint updated successfully': 'Complaint created successfully', convertedComplaint);
                const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'ComplaintsEntity', convertedComplaint.complaintId, true, '',convertedComplaint.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            }else{
                throw new ErrorResponse(11106, 'Complaint is saved but issue while transforming into DTO');
            }
        }catch(error){
            throw error;
        }
    }

    async getAllComplaints(): Promise<AllComplaintsResponseModel>{
        try{
            const complaintsDto: ComplaintsDTO[] = [];
            const complaintsEntities: ComplaintsEntity[] = await this.complaintsRepo.find({
                order: {createdAt: 'DESC'},
            });

            if(complaintsEntities.length > 0){
                complaintsEntities.forEach(Entity => {
                    const convertedDto: ComplaintsDTO = this.complaintsAdapter.convertEntityToDto(Entity);
                    complaintsDto.push(convertedDto);
                });
                const response = new AllComplaintsResponseModel(true, 11208, 'Complaints retrieved successfully', complaintsDto);
                const newLogDto = new LogsDto(1,'view', 'ComplaintsEntity', 0, true, '','')
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            }else{
                throw new ErrorResponse(99998, 'No Records found');
            }
        }catch(error){
            throw error;
        }
    }

    async getComplaintById(id: number): Promise<ComplaintsEntity>{
        const response = await this.complaintsRepo.findOne({
            where: {complaintId: id},
        });
        if(response){
            return response;
        }else{
            return null;
        }
    }

    async activateOrDeactivateComplaint(req: ComplaintsRequest): Promise<ComplaiintsResponseModel>{
        try{
            const complaintExists = await this.getComplaintById(req.complaintId);
            if(complaintExists){
                if(req.versionFlag != complaintExists.versionFlag){
                    throw new ErrorResponse(10113, 'Someone update the current complaint information. Refresh and try again');
                }else{
                    const complaintStatus =  await this.complaintsRepo.update(
                        {complaintId:  req.complaintId},
                        {isActive: req.isActive, updatedUser: req.updatedUser},
                    );
                    if(complaintExists.isActive){
                        if(complaintStatus.affected){
                            const response: ComplaiintsResponseModel = new ComplaiintsResponseModel(true, 10115, 'Complaint is de-activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10111, "Complaint is already de-activated");                        
                        }
                    }else{
                        if(complaintStatus.affected){
                            const response: ComplaiintsResponseModel = new ComplaiintsResponseModel(true, 10114, 'Complaint is activated successfully');
                            return response;
                        }else{
                            throw new ErrorResponse(10112, 'Complaint is already activated');
                        }
                    }
                }
            }else{
                throw new ErrorResponse(99998, 'No Records Found');
            }
        }catch(error){
            throw error;
        }
    }
}


